import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, TermFilter, FilterOptions, GradeLevelOptions } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/teacher-courses/TeacherCoursesAction";
import { useTeacherCoursesUIContext } from "../TeacherCoursesUIContext";

const prepareFilter = (queryParams, values) => {
  const { term, gradeLevel, sectionId, teacherId, branchId, courseId } = values;
  const newQueryParams = { ...queryParams };
  const filter = { gradeLevel, sectionId, teacherId, branchId, courseId };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function TeacherCoursesFilter() {
  // Teacher Courses UI Context
  const teacherCoursesUIContext = useTeacherCoursesUIContext();
  const teacherCoursesUIProps = useMemo(() => {
    return {
      setQueryParams: teacherCoursesUIContext.setQueryParams,
      queryParams: teacherCoursesUIContext.queryParams,
    };
  }, [teacherCoursesUIContext]);

  const dispatch = useDispatch();
  const { currentActiveTerm, sections, teachers, branches, courses } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm,
      sections: state.teacherCourses.sections,
      teachers: state.teacherCourses.teachers,
      branches: state.teacherCourses.branches,
      courses: state.teacherCourses.courses
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getAllList());
  }, [dispatch]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(teacherCoursesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, teacherCoursesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      teacherCoursesUIProps.setQueryParams(newQueryParams);
    }
  };
  
  const sectionOptions = FilterOptions.concat(sections);
  const gradeLevelOptions = FilterOptions.concat(GradeLevelOptions);
  const courseOptions = FilterOptions.concat(courses);
  const teacherOptions = FilterOptions.concat(teachers);
  const branchOptions = FilterOptions.concat(branches);

  return (
    <Formik
      initialValues={{
        term: currentActiveTerm
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <TermFilter
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values}
          />
          <div className="form-group row">
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeLevelOptions}
                value={values.gradeLevel}
                placeholder="Sınıf Düzeyi"
                onBlur={handleBlur}
                onChange={e => {
                  dispatch(actions.getSections(e.value));
                  setFieldValue("gradeLevel", e.value);
                  setFieldValue("sectionId", undefined);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf Düzeyi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={sectionOptions}
                value={values.sectionId}
                placeholder="Sınıf"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sectionId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={teacherOptions}
                value={values.teacherId}
                placeholder="Öğretmen"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("teacherId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğretmen</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={branchOptions}
                value={values.branchId}
                placeholder="Branş"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("branchId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Branş</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={courseOptions}
                value={values.courseId}
                placeholder="Ders"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("courseId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Ders</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}